 
import { createSlice, createAsyncThunk, createAction } from "@reduxjs/toolkit";
import {courseService} from "./courseServices";

// Async actions
export const getAllCourses = createAsyncThunk("course/get-courses", async (_, thunkAPI) => {
  try {
    return await courseService.getCourses();
  } catch (error) {
    return thunkAPI.rejectWithValue(error);
  }
});

 

export const getACourse = createAsyncThunk("course/get-course", async (id, thunkAPI) => {
  try {
    return await courseService.getCourse(id);
  } catch (error) {
    return thunkAPI.rejectWithValue(error);
  }
});

 
 

export const resetState = createAction("Reset_all");

const initialState = {
  courses: [],
  isLoading: false,
  isError: false,
  isSuccess: false,
  message: "",
};

export const courseSlice = createSlice({
  name: "courses",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getAllCourses.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getAllCourses.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.courses = action.payload;
      })
      .addCase(getAllCourses.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })


      .addCase(getACourse.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getACourse.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.singleCourse = action.payload;
      })
      .addCase(getACourse.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })
 
 

      .addCase(resetState, () => initialState);
  },
});

export default courseSlice.reducer;
